__gh__webApp.weather.accuweather 	= {
	
	"showAlert": function(callback){
		var commonJS	= __gh__webApp.common,
			isEnabled	= commonJS.getObjectProperty(__gh__coreData["3rdPartyData"],"weather.accuweather.enableAlert"),
			injectView 	= __gh__webApp.utilities.fetch.handlebarsView.append;
		
		if(!isEnabled){
			if (callback){
				callback();
			}
			return;
		
		}
		
		/*injectView({
			"dom"	: $("#content .alert")[0],
			"view"	: "alerts/default",
			"data"	:{
				"class"	: "alert-weather",
				"link"	: "http://google.com",
				"title"	: "Weather Alert",
				"icon"	: "fa-bolt"
			}
		});*/
		
		
		if (callback){
			callback();
		}

	}
};